import { render, staticRenderFns } from "./ParamOcupacaoForm.vue?vue&type=template&id=d9886a68"
import script from "./ParamOcupacaoForm.vue?vue&type=script&lang=js"
export * from "./ParamOcupacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports